import { Button } from '@octano/global-ui';
import { Trans } from 'react-i18next';
import { useHistory } from 'react-router';
import { Col, Row } from 'reactstrap';

import { ReactComponent as CompletedImage } from '../../../../../../assets/svg/completed_image.svg';

const CompletedErp = ({
  title,
  body,
  searchText,
}: {
  title: string;
  body: string;
  searchText: string;
}) => {
  const history = useHistory();

  return (
    <>
      <Row>
        <Col xs={12}>
          <div
            className="d-flex py-4 flex-column align-items-center m-auto"
            style={{ maxWidth: '694px', gap: 24 }}
          >
            <CompletedImage width="230px" />
            <span className="text-center fs-20 text-dark">{title}</span>
            <span className="text-center fs-18 fw-300">
              <Trans i18nKey={body} />
            </span>
          </div>
        </Col>
      </Row>
      <Row className="pt-3 pb-5 justify-content-end">
        <Col xs={12}>
          <Button
            className="mx-auto"
            style={{ maxWidth: 694 }}
            text={searchText}
            onClick={() => history.replace('/tuition-process')}
            fullwidth
          />
        </Col>
      </Row>
    </>
  );
};

export default CompletedErp;
